// El aviso de oferta nueva en todo el portal (PP-71): suena una vez por oferta
// nueva del filtro de planta global y marca el titulo de la pestana con lo
// pendiente, este abierta la seccion que este. No pinta nada: el interruptor
// de silencio esta en el menu de cuenta y las ofertas en el Inicio y en Viajes.
//
// Lee la encuesta compartida (OffersFeed.tsx), no pide nada por su cuenta.
import { useEffect, useMemo, useState } from "react";
import { pendingNow } from "../logic/home.js";
import { offersInScope } from "../logic/offer-alert.js";
import type { Clock } from "../requests/clock.js";
import type { SiteAccess } from "../sites/port.js";
import { useOfferAlert, usePendingTitle, type Chime } from "./offerAlertState.js";
import { useOffersFeed } from "./OffersFeed.js";

/** El titulo sigue a los relojes de las ofertas: una que vence deja de contar. */
const TICK_MS = 1_000;

interface Props {
  /** Todas las habilitaciones de la cuenta. */
  sites: readonly SiteAccess[];
  /** Filtro de planta global; `null` es "Todas". */
  siteId: string | null;
  muted: boolean;
  chime: Chime;
  clock: Clock;
}

export function OfferAlert({ sites, siteId, muted, chime, clock }: Props): null {
  const { state } = useOffersFeed();
  const items = state.estado === "listo" ? state.data.items : undefined;
  const inScope = useMemo(() => (items === undefined ? undefined : offersInScope(items, sites, siteId)), [items, sites, siteId]);
  useOfferAlert(inScope?.all, inScope?.scoped ?? [], muted, chime);

  const [now, setNow] = useState(() => clock.now());
  useEffect(() => {
    setNow(clock.now());
    return clock.every(TICK_MS, () => setNow(clock.now()));
  }, [clock]);
  usePendingTitle(inScope === undefined ? 0 : pendingNow(inScope.scoped, now));
  return null;
}
